import React, { useState } from 'react';
import PublicChatWidget from './PublicChatWidget';

interface ChatBubbleProps {
  language: 'en' | 'es';
}

const ChatBubble: React.FC<ChatBubbleProps> = ({ language }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <PublicChatWidget isOpen={isOpen} onClose={() => setIsOpen(false)} language={language} />
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        className="fixed bottom-20 right-4 z-50 md:bottom-6 flex items-center gap-2 rounded-full bg-blue-700 px-4 py-3 text-white shadow-lg hover:bg-blue-800 transition-all"
        aria-label={language === 'es' ? 'Abrir chat' : 'Open chat'}
      >
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" />
        </svg>
        <span className="text-sm font-semibold hidden sm:inline">
          {language === 'es' ? 'Preguntar' : 'Ask Us'}
        </span>
      </button>
    </>
  );
};

export default ChatBubble;
